var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hb-tabs", attrs: { role: "tablist" } },
    _vm._l(_vm.tabs, function (tab) {
      return _c(
        "button",
        {
          key: tab.key,
          staticClass: "hb-tabs__tab",
          class: { "hb-tabs__tab--active": tab.key === _vm.value },
          attrs: {
            type: "button",
            role: "tab",
            "aria-selected": tab.key === _vm.value ? "true" : "false",
          },
          on: {
            click: function ($event) {
              return _vm.select(tab.key)
            },
          },
        },
        [
          _vm._v(" " + _vm._s(tab.label) + " "),
          tab.count !== undefined && tab.count !== null
            ? _c("span", { staticClass: "hb-tabs__count" }, [
                _vm._v(_vm._s(tab.count)),
              ])
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }